<template>
    <div
        :class="{
            'form-group': true,
            'has-error': invalid,
            'has-input': selected || (autosuggest && inp_clicked)
        }"
        v-click-outside="click_outside"
    >
        <div :class="{ drop: true, show: drop_shown, focus: focus }">
            <a href="javascript:{}" class="drop-toggle" @click="show_drop">
                <div class="placeholder show">
                    <label>{{ label }}</label>
                    <span v-if="required" class="star">*</span>
                </div>
                <span v-if="selected && !autosuggest" class="drop-text">{{ selected_label }}</span>
                <input
                    v-if="autosuggest"
                    v-model="inp"
                    @click="input_clicked"
                    autocomplete="off"
                    @input="search"
                    class="no-input auto-input"
                />
                <input
                    v-if="false"
                    v-model="inp"
                    @input="search"
                    readonly
                    v-else
                    class="no-input auto-input"
                    placeholder="Select value"
                />
            </a>
            <span @click="reset" v-if="value || (this.inp && this.inp.length > 0)" class="icon icon-reset"></span>
            <span v-else class="icon icon-drop" style="pointer-events:none;"></span>

            <div class="drop-content drop-right">
                <ul class="drop-menu" ref="dropdown_list_container">
                    <li v-for="opt in sorted_options">
                        <a @click="select_option(opt.value)" href="javascript:{}">{{ opt.label }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import vClickOutside from "v-click-outside";

export default {
    name: "dropdown",
    props: ["options", "value", "required", "label", "name", "invalid", "unsort", "autosuggest"],
    mounted() {},
    data() {
        return {
            inp: this.autosuggest && this.value ? this.value : null,
            opts: [...this.options],
            inp_clicked: false,
            focus: false,
            selected: this.value ? this.value : null,
            drop_shown: false
        };
    },
    watch: {
        value: {
            handler: function(newVal, old_val) {
                if (this.value) {
                    this.selected = this.value;
                    if (this.autosuggest && this.value && this.value.length > 0) {
                        this.inp = this.value;
                    }
                } else {
                    this.selected = null;
                }
            }
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {},
    computed: {
        sorted_options() {
            if (!this.unsort) {
                return this.opts.sort(function(a, b) {
                    if (a.label < b.label) {
                        return -1;
                    }
                    if (a.label > b.label) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                return this.opts;
            }
        },
        selected_label() {
            var result = this.opts.find(obj => {
                return obj.value === this.selected;
            });
            if (result) {
                return result.label;
            } else {
                return null;
            }
        }
    },
    methods: {
        click_outside() {
            if (this.drop_shown) {
                this.drop_shown = false;
                this.focus = false;
            }
        },
        input_clicked() {
            this.inp_clicked = true;
        },
        reset() {
            this.inp = null;
            this.selected = null;
            if (this.autosuggest) {
                this.inp_clicked = false;
            }
            this.$emit("selected", { name: this.name, value: this.selected });
        },
        search() {
            if (this.inp && this.inp.length > 0) {
                this.opts = [...this.options];
                this.opts = this.opts.filter(opt => {
                    return opt.label.toLowerCase().includes(this.inp.toLowerCase());
                });
            } else {
                if (this.autosuggest) {
                    this.opts = [...this.options];
                    this.opts = this.opts.filter(opt => {
                        return opt.label.toLowerCase().includes(this.inp.toLowerCase());
                    });
                } else {
                    this.opts = [...this.options];
                }
            }
        },
        select_option(value) {
            this.drop_shown = false;
            this.focus = false;
            this.selected = value;
            if (this.autosuggest) {
                this.inp = value;
            }
            this.$emit("selected", { name: this.name, value: this.selected });
        },
        show_drop() {
            this.drop_shown = !this.drop_shown;
            if (!this.drop_shown) {
                this.focus = false;
            } else {
                this.focus = true;
            }
            Vue.nextTick(() => {
                let target = this.$refs.dropdown_list_container;
                target.scrollTop = 0;
            }, 500);
        }
    }
};
</script>

<style scoped></style>
